import { render, staticRenderFns } from "./ImageUploadMultipleItem.vue?vue&type=template&id=0defb55b"
import script from "./ImageUploadMultipleItem.vue?vue&type=script&lang=js"
export * from "./ImageUploadMultipleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports